import { Trans } from '@lingui/react/macro';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@repo/videa-components/src/index';

import { formatBoneLevel } from '@/modules/claims/cleanClaims/helpers';
import type { SrpTooth } from '@/modules/claims/freeClaims/insuranceExport/types';

type SrpTreatmentsTableProps = {
  uniqueTeeth: SrpTooth[];
};

export const SrpTreatmentsTable = ({
  uniqueTeeth,
}: SrpTreatmentsTableProps) => {
  return (
    <div className="vai-flex vai-flex-col vai-gap-2">
      <div className="vai-flex vai-flex-col vai-gap-2">
        <Table className="vai-border vai-border-slate-200">
          <TableHeader>
            <TableRow className="vai-bg-slate-50">
              <TableHead className="vai-text-xs">
                <Trans>TOOTH</Trans>
              </TableHead>
              <TableHead className="vai-text-xs">
                <Trans>Tx CODE</Trans>
              </TableHead>
              <TableHead className="vai-text-xs">
                <Trans>POTENTIAL CALCULUS FINDINGS</Trans>
              </TableHead>
              <TableHead className="vai-text-xs">
                <Trans>RBL MESIAL</Trans>
              </TableHead>
              <TableHead className="vai-text-xs">
                <Trans>RBL DISTAL</Trans>
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {uniqueTeeth.map((tooth) => (
              <TableRow key={tooth.toothId}>
                <TableCell>{tooth.toothId}</TableCell>
                <TableCell>
                  {tooth.txCodes.map((code, index) => (
                    <div key={index}>{code}</div>
                  ))}
                </TableCell>
                <TableCell>
                  {/* Use svg directly instead of FontAwesomeIcon to avoid
                  rendering issues with the icon when downloading attachment */}
                  {tooth.potentialCalculus ? (
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.3333 4L6 11.3333L2.66667 8"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ) : (
                    '--'
                  )}
                </TableCell>
                <TableCell>
                  {formatBoneLevel(tooth.mesial, tooth.measurementType) ?? '--'}
                </TableCell>
                <TableCell>
                  {formatBoneLevel(tooth.distal, tooth.measurementType) ?? '--'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
